/**
 * Professional Ripple Paint Worklet
 * 
 * Provides a high-performance interaction feedback effect with configurable:
 * - Color and Alpha
 * - Radius and Expansion Speed
 * - Smooth easing based on input time/progress
 */

class Ripple {
  static get inputProperties() {
    return [
      '--fluent-ripple-color',
      '--fluent-ripple-x',
      '--fluent-ripple-y',
      '--fluent-ripple-progress',
      '--fluent-ripple-max-radius'
    ];
  }

  paint(ctx: CanvasRenderingContext2D, size: { width: number; height: number }, props: any) {
    const x = parseFloat(props.get('--fluent-ripple-x')) || size.width / 2;
    const y = parseFloat(props.get('--fluent-ripple-y')) || size.height / 2;
    const progress = parseFloat(props.get('--fluent-ripple-progress')) || 0;
    const color = props.get('--fluent-ripple-color').toString() || 'rgba(0, 0, 0, 0.1)';
    const maxRadius = parseFloat(props.get('--fluent-ripple-max-radius')) || 
                    Math.hypot(size.width, size.height);

    if (progress <= 0 || progress >= 1) return;

    // Use an easing function for more organic expansion
    const easeProgress = this.easeInOutQuart(progress);
    const currentRadius = maxRadius * easeProgress;
    const opacity = 1 - easeProgress;

    ctx.save();
    ctx.beginPath();
    ctx.arc(x, y, currentRadius, 0, 2 * Math.PI);
    
    // Adjust alpha based on progress
    ctx.globalAlpha = opacity;
    ctx.fillStyle = color;
    ctx.fill();
    ctx.restore();
  }

  /**
   * Quartic easing for natural motion
   */
  private easeInOutQuart(t: number): number {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  }
}

registerPaint('fluent-ripple', Ripple);
